/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { computed } from 'mobx';
import { AzureSku } from 'src/core/stores/AzureCsAccountStore';
import { AuthTokenType } from 'src/core/stores/types';
import { Region } from 'src/core/types/regionTypes';

/**
 * Represents a Azure storage account .
 */
export class AzureStorageAccountStore {
    public readonly id: string;

    public readonly path: string;

    public readonly name: string;

    public readonly sku: AzureSku;

    public readonly location: Region;

    public readonly azureStorageKind: string;

    public readonly tokenSource: AuthTokenType;

    constructor(id: string, azureStorageAccountData: Partial<Omit<AzureStorageAccountStore, 'id'>>) {
        this.id = id;
        this.path = azureStorageAccountData.path ?? id;
        this.name = azureStorageAccountData.name;
        this.sku = azureStorageAccountData.sku;
        this.azureStorageKind = azureStorageAccountData.azureStorageKind;
        this.location = azureStorageAccountData.location;
        this.tokenSource = azureStorageAccountData.tokenSource ?? 'userToken';
    }

    @computed
    public get resourceGroupName() {
        const pathSegments = this.id.split('/');
        const resourceGroupIndex = pathSegments.findIndex(s => s.toLocaleLowerCase() === 'resourcegroups');

        return pathSegments[resourceGroupIndex + 1];
    }

    @computed
    public get subscriptionId() {
        const pathSegments = this.path.split('/');
        const subscriptionIndex = pathSegments.findIndex(s => s.toLocaleLowerCase() === 'subscriptions');

        return pathSegments[subscriptionIndex + 1];
    }
}
